<template>
    <div 
        class="popup"
        :class="{ active: open }"
        @click="close">
        <div class="modal" @click.stop="">
            <div class="header">
                {{headerTitle}}
            </div>
            <div class="content">
                <slot></slot>
            </div>
            <div class="footer" v-if="confirmType">
                <button class="fluke-btn fluke-grey" @click="accept(false)">{{this.cancelTitle}}</button>
                <button class="fluke-btn" @click="accept(true)">{{this.confirmTitle}}</button>
            </div>
            <div class="footer" v-else>
                <button class="fluke-btn" @click="accept(true)">{{this.confirmTitle}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function()
    {
        return {
            open: false,
            promiseResolve: null,
            promiseReject: null,
            confirmType: false,
            cancelTitle: 'Cancelar',
            confirmTitle: 'Confirmar',
            headerTitle: 'Confirmar'
        }
    },
    created: function()
    {
        if( this.$attrs.cancel ) this.cancelTitle = this.$attrs.cancel;
        if( this.$attrs.confirm ) this.confirmTitle = this.$attrs.confirm;
        if( this.$attrs.title ) this.headerTitle = this.$attrs.title;
    },
    methods: {
        alert: function()
        {
            this.open = true;
            this.confirmType = false;

            var _ref = this;
            new Promise(function(resolve, reject) {
                _ref.promiseResolve = resolve;
                _ref.promiseReject = reject;
            }.bind(this));
        },
        close: function()
        {
            this.promiseReject(false);
            this.open = false;
        },
        accept: function(value)
        {
            if (value) this.promiseResolve(true);
            else this.promiseReject(false);
            
            this.open = false;

        },
        confirm: function()
        {
            this.open = true;
            this.confirmType = true;
            var _ref = this;

            return new Promise(function(resolve, reject) {
                _ref.promiseResolve = resolve;
                _ref.promiseReject = reject;
            }.bind(this));
        }
    }
}
</script>

<style lang="scss">
.popup
{
    position: fixed;
    background: rgba(0,0,0,0);
    top: 0;
    left: 0;
    width: 100%;
    height: 0%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    opacity: 0;
    transition: height 0ms, background 400ms;
    z-index: 300;


    &.active {
        height: 100%;
        background: rgba(0,0,0,0.6);
        opacity: 1;
    }

    .modal
    {
        // height: 150px;
        min-height: 100px;
        max-height: 98%;
        min-width: 500px;
        background-color: #ffffff;
        border-radius: 3px;
        opacity: 0;
        box-shadow: 0 0 3px 3px rgba(0,0,0,0.1);
        transition: opacity 1s;
        overflow: auto;

        .header
        {
            font-size: 20px!important;
            font-weight: 500;
            letter-spacing: .02em!important;
            font-family: Roboto,sans-serif !important;
            padding: 15px;
        }

        .content
        {
            padding: 20px 15px 25px 15px;
        }

        .footer {
            padding: 15px;
            text-align: right;
            border-top: 1px solid #f1f1f1;

            button {
                width: 150px;
                margin-left: 10px;
            }
        }
    }

    &.active {
        height: 100%;
        background: rgba(0,0,0,0.6);
        opacity: 1;

        .modal {
            opacity: 1;
        }
    }
}
</style>

